export const sitemap = (obj) => {
    return `
        <section class="sitemap__section">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="sitemap__content">
                            <h1 class="page__header">Nettstedskart</h1>
                            ${obj.content}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    `;
}
export const category = (obj) => {
    const href = obj.item.externallink.trim() !== "" ? obj.item.externallink.trim() : `/nav/${obj.item.full_url}`;
    return `
        <div class="sitemap__category level-${obj.level}">
            <a href="${href}">${obj.item.previewItem}</a>
        </div>
    `;
}
export const article = (obj) => {
    return `
        <div class="sitemap__article level-${obj.level}">
            <a href="/artikkel/${obj.item.contentId}">${obj.item.title}</a>
        </div>
    `;
}